module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Medium.1f781518.otf";